import React from "react";
import { Pencil, Trash2 } from "lucide-react";

/**
 * PhaseItem
 *
 * Props:
 * - phase: phase object
 * - onEdit()
 * - onDelete()
 */
export default function PhaseItem({ phase, onEdit, onDelete }) {
  return (
    <li className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition">
      {/* Phase info */}
      <div>
        <div className="text-sm font-medium text-gray-900">
          {phase.name}
        </div>

        {(phase.startDate || phase.endDate) && (
          <div className="mt-0.5 text-xs text-gray-500">
            {phase.startDate && (
              <span>
                {new Date(phase.startDate).toLocaleDateString()}
              </span>
            )}
            {phase.startDate && phase.endDate && " → "}
            {phase.endDate && (
              <span>
                {new Date(phase.endDate).toLocaleDateString()}
              </span>
            )}
          </div>
        )}

        {phase.description && (
          <div className="mt-1 text-xs text-gray-500">
            {phase.description}
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        <button
          onClick={onEdit}
          className="rounded p-1 text-gray-400 hover:text-indigo-600"
          title="Edit phase"
        >
          <Pencil className="w-4 h-4" />
        </button>

        <button
          onClick={onDelete}
          className="rounded p-1 text-gray-400 hover:text-rose-600"
          title="Delete phase"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </li>
  );
}